import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-0fd8da43"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "card"
};
var _hoisted_2 = {
  class: "card-header"
};
var _hoisted_3 = {
  class: "card-body"
};

var _hoisted_4 = /*#__PURE__*/_createTextVNode("卡片体");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_font_awesome_icon = _resolveComponent("font-awesome-icon");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", {
    style: _normalizeStyle($setup.headerIconStyle)
  }, [_createVNode(_component_font_awesome_icon, {
    icon: $props.icon,
    class: "header-icon"
  }, null, 8, ["icon"])], 4), _createElementVNode("span", null, _toDisplayString($props.title), 1)]), _createElementVNode("div", _hoisted_3, [_renderSlot(_ctx.$slots, "default", {}, function () {
    return [_hoisted_4];
  }, true)])]);
}